export default "__VITE_ASSET__yinSl2zD__"